export default __webpack_public_path__ + "static/media/Cognitive_Mobile@2x.81cc5b25.png";